import { render, staticRenderFns } from "./ApplicationsManage.vue?vue&type=template&id=10da6e71&"
import script from "./ApplicationsManage.vue?vue&type=script&lang=js&"
export * from "./ApplicationsManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports